// extracted by mini-css-extract-plugin
export default {"SignButton":"_SignButton--ZHUug","Collapsed":"_Collapsed--RwJ2D"};